import { useAppState } from '@sky-distribution/gp-onboarding-app-state-service';
import { redirect } from '@sky-distribution/gp-onboarding-shared-utils';
import { FC, Fragment, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ERROR_NS } from '../../config/translations';
import {
  GeneralPageButton,
  GeneralPageContainer,
  GeneralPageContent,
  GeneralPageGrid,
  GeneralPageImage,
  GeneralPageMessage,
  GeneralPagePicture,
  GeneralPageText,
} from './GeneralPage.styles';
import { GeneralPageProps } from './GeneralPage.types';

export const GeneralPage: FC<GeneralPageProps> = ({
  errorImg, title, maxWidth, url, resetError, children, buttonText,
}) => {
  const { t } = useTranslation(ERROR_NS);
  const { previous } = useAppState();

  const reset = useMemo(() => (resetError || previous), [resetError, previous]);

  return (
    <GeneralPageContainer>
      <GeneralPageGrid>
        <GeneralPageMessage component="h1">
          {title || t('GeneralError.Title')}
        </GeneralPageMessage>
        <GeneralPagePicture maxWidth={maxWidth}>
          <GeneralPageImage src={errorImg} />
        </GeneralPagePicture>
        <GeneralPageContent>
          <GeneralPageButton data-e2e='button' onClick={reset} blockMode>
            {buttonText ?? t('GeneralError.Button.Return')}
          </GeneralPageButton>
          {url && (
            <Fragment>
              <GeneralPageText>{t('GeneralError.Or')}</GeneralPageText>
              <GeneralPageButton
                onClick={() => redirect({ url })}
                typeStyle="outlined"
                blockMode
              >
                {t('GeneralError.Button.Contact')}
              </GeneralPageButton>
            </Fragment>
          )}
          {children}
        </GeneralPageContent>
      </GeneralPageGrid>
    </GeneralPageContainer>
  );
};
